export default __webpack_public_path__ + "static/2019_2020_WVS INDIA CONSOLIDATED ACCOUNTS-9ce88119e167b7694227fdf88eaacf64.pdf";